import { ChannelType } from 'common/core/constants/ChannelType'
import { TriggerType } from 'common/flow/constants/TriggerType'
import { ITriggerId } from 'common/flow/flowTriggersInterfaces'
import { MappedLightFlow } from 'shared/api/common/schemas/flow'
import {
  TikTokFollowWelcomeInteraction,
  TikTokFollowWelcomeQuickAction,
  TikTokFollowWelcomeStatus,
} from 'shared/api/requests/tiktok/schemas'

export interface TikTokFollowWelcomeMessage {
  message: string
  interaction: TikTokFollowWelcomeInteraction
  quickReplyText: string | null
  quickActionType: TikTokFollowWelcomeQuickAction | null
}

export interface TikTokFollowWelcomeFlowTrigger {
  id: string
  triggerType: TriggerType.FOLLOW_WELCOME
  triggerId: ITriggerId
  channel: ChannelType
  enabled: boolean
  caption: string
  flowId: string | null
  flow: MappedLightFlow | null
  ctr?: number | null
  runs?: number
  clicked_unq?: number
  ts_created: number
}

export interface TikTokFollowWelcomeState {
  flowId: string | null
  enabled: boolean
  messageEnabled: boolean
  auditStatus: TikTokFollowWelcomeStatus | null
  followWelcome: TikTokFollowWelcomeMessage | null
  isFetched: boolean
  isToggling: boolean
  isMessageFetched: boolean
  isMessageLoadFailed: boolean
  isMessageToggling: boolean
}

export type TikTokFollowWelcomeTriggerState = Pick<
  TikTokFollowWelcomeState,
  'flowId' | 'enabled' | 'isFetched'
>

export type TikTokFollowWelcomeMessageState = Pick<
  TikTokFollowWelcomeState,
  'messageEnabled' | 'auditStatus' | 'followWelcome' | 'isMessageFetched' | 'isMessageLoadFailed'
>

export enum TikTokFollowWelcomeSetupStep {
  INTRO = 'intro',
  MESSAGE = 'message',
}

export interface TikTokFollowWelcomeSetupModalState {
  isOpen: boolean
  step: TikTokFollowWelcomeSetupStep
}

export interface TikTokFollowWelcomeMessageFormValues {
  message: string
}
